<template>
    <div>
        <page-header :heading="pageHeader.title"
                     :buttons="pageHeader.buttons" />

        <hr />

        <div>
            <div class="form-inline">
                <label class="sr-only" for="newLabel">Label</label>
                <input type="text" v-model="newLabel" class="form-control form-control-sm mb-2 mr-sm-2" id="newLabel" placeholder="Label">
                <label class="sr-only" for="ruleComp">Name</label>
                <select id="newType" class="form-control form-control-sm mb-2 mr-sm-4" v-model="newType">
                    <option :value="null" disabled>Select a Type...</option>
                    <option v-for="type in pipelineTypeList" :key="type.label" v-bind:value="type">
                        {{ type.label }}
                    </option>
                </select>
                <div class="custom-control custom-checkbox  mb-2 mr-sm-4">
                    <input type="checkbox" class="custom-control-input" id="newEnabled" v-model="newEnabled">
                    <label class="custom-control-label" for="newEnabled">Enabled</label>
                </div>
                <button class="btn btn-sm btn-primary mb-2" @click="handleAddPipelineClick">Add Pipeline</button>
            </div>
        </div>
        
     
        <data-list :dataCols="pipelineCols"
                   :dataListItems="pipelineList"
                   :tableClass="'table table-striped table-sm'"
                   @sgl-click="handleItemClick" />
        <hr />
        <div>
            <div class="form-inline">
                <label class="sr-only" for="ruleComp">Name</label>
                <select id="ruleComp" class="form-control form-control-sm mb-2 mr-sm-4" v-model="newRule">
                    <option :value="null" disabled>Select a Rule...</option>
                    <option v-for="rule in ruleComponentList" :key="rule.label" v-bind:value="rule">
                        {{ rule.label }}
                    </option>
                </select>

                <div class="custom-control custom-checkbox  mb-2 mr-sm-4">
                    <input type="checkbox" class="custom-control-input" id="newRuleEnabled" v-model="newRuleEnabled">
                    <label class="custom-control-label" for="ruleEnabled">Enabled</label>
                </div>
                <button class="btn btn-sm btn-primary mb-2" @click="handleAddRuleClick">Add Rule</button>
            </div>

        </div>

        

        <data-list :dataCols="piplineRuleCols"
                   :dataListItems="pipelineRuleList"
                   :tableClass="'table table-striped table-sm'" />

        <hr />

        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>
</template>

<script>

//import OrderBy from '@/components/OrderBy.vue'
import PageHeader from '@/components/PageHeader.vue'
import DataList from '@/components/DataList.vue'
//import DataListCSV from '@/components/DataListCSV.vue'


//import PageSize from '@/components/PageSize.vue'
//import SearchForm from '@/components/SearchForm.vue'
import { searchInputs } from '@/ui.config/inputs/claimsBucket1SearchInputs'
import { pipelineCols, piplineRuleCols } from '@/ui.config/cols/pipelineCols'

import { mapActions } from 'vuex'

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name:'Pipelines',
    mixins: [

    ],
    components: {
        PageHeader,
        DataList,
        //'data-list-csv': DataListCSV,
        //PageSize,
        //SearchForm,
        Loading,
        //OrderBy
    },
    data: () => {
        return {
            pageHeader: {
                title: 'Pipelines',
            },
            searchInputs: searchInputs,
            pipelineCols: pipelineCols,
            piplineRuleCols: piplineRuleCols,

            newLabel: null,
            newType: null,
            newEnabled: true,

            newRule: null,
            newRuleEnabled: true,

            // Override mixin
            orderByOptions: [
                {
                    id: 0,
                    key: 'ClaimantEmail',
                    label: 'Claimant Email'
                },
                {
                    id: 1,
                    key: 'DateCreated',
                    label: 'Submitted Date'
                },
                {
                    id: 2,
                    key: 'IncidentDate',
                    label: 'incident Date'
                }
            ]
        }
    },
    beforeMount() {
        this.fetchPipelines({})
        this.$store.commit('setPipelineRules', null)
        this.fetchPipelineTypes()
        this.fetchRuleComponents()
        this.fetchResellers()
        this.fetchIncidentTypes()
        this.setSelectedPipeline(null)
    },
        computed: {
        isLoading() {
            return this.$store.getters.isLoading
        },
        searchInputsEx() {
            var { resellers, incidentTypes,  searchInputs } = this

            if (resellers) {
                searchInputs[0].options = resellers
            }

            if (incidentTypes) {
                searchInputs[5].options = incidentTypes
            }

            return searchInputs
        },
        pipelineList() {
            return this.$store.getters.pipelineList
        },
        selectedPipeline() {
            return this.$store.getters.selectedPipeline
        },
        pipelineTypeList() {
            return this.$store.getters.pipelineTypeList
        },
        pipelineRuleList() {
            return this.$store.getters.pipelineRuleList
        },
        ruleComponentList() {
            return this.$store.getters.ruleComponents
        }
    },
    methods: {
        ...mapActions([
            'fetchPipelines',
            'fetchPipelineTypes',
            'fetchPipelineRules',
            'fetchResellers',
            'fetchIncidentTypes',
            'setSelectedPipeline',
            'fetchRuleComponents',
            'addPipelineRule',
            'addPipeline'
        ]),
        handleItemDblClick(payload) {
            this.setSelectedPipeline(payload)
            let { id: pipelineId } = payload
            this.fetchPipelineRules({ pipelineId : pipelineId})
        },
        handleItemClick(payload) {
            this.setSelectedPipeline(payload[0])
            let { id: pipelineId } = payload[0]
            this.fetchPipelineRules({ pipelineId: pipelineId })
        },
        handleAddRuleClick() {
            let { id: ruleId } = this.newRule
            let { id: pipelineId } = this.selectedPipeline
            this.addPipelineRule({ ruleId, pipelineId })
            this.newRule = null
        },
        handleAddPipelineClick() {
            let { newLabel: label, newType: pipelineType, newEabled: enabled } = this
            this.addPipeline({ label, pipelineTypeId: pipelineType.id, enabled })
        },
    }
}
</script>

<style>
</style>
